import React from "react";

import TextGenerator from "./TextGenerator";
import LinkGenerator from "./LinkGenerator";
import ParagraphGenerator from "./ParagraphGenerator";

const DEFAULT_GENERATORS = {
	...TextGenerator,
	...LinkGenerator,
	...ParagraphGenerator,
};

export default function generate({ nodes }) {
	const jsxArray = nodes.map((node, idx) => {
		const generator = DEFAULT_GENERATORS[node.type];

		const reactNode = generator({
			node,
			nodesToJSX: (args) => {
				return generate({
					nodes: args.nodes,
				});
			},
		});

		// Add key prop to the generated element
		if (React.isValidElement(reactNode)) {
			return React.cloneElement(reactNode, {
				key: idx,
			});
		}

		return reactNode;
	});

	return jsxArray.filter(Boolean);
}
